/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarksSubmissionDto } from '../../models/survey-marks-submission-dto';
import { UpdateSurveyMarkSubmissions } from '../../models/update-survey-mark-submissions';

export interface UpdateSurveyMarksSubmission$Params {
  submissionId: number;
  body: UpdateSurveyMarkSubmissions;
}

export function updateSurveyMarksSubmission(
  http: HttpClient,
  rootUrl: string,
  params: UpdateSurveyMarksSubmission$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksSubmissionDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    updateSurveyMarksSubmission.PATH,
    'put',
  );
  if (params) {
    rb.path('submissionId', params.submissionId, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksSubmissionDto>;
      }),
    );
}

updateSurveyMarksSubmission.PATH = '/me/surveyMarks/submissions/{submissionId}';
